import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { loginApi } from '../api';
import { Logo } from '../components/Layout';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCargando(true);
    try {
      const res = await loginApi(form);
      login(res.data.token, res.data.usuario);
      navigate('/');
    } catch(err) {
      setError(err.response?.data?.error || 'Error al iniciar sesion');
    } finally { setCargando(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(160deg, #0a2a4a 0%, #0d4a2a 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Logo white />
          <p style={{ color: '#9ecfb8', fontSize: 13, marginTop: 8 }}>Soporte tecnico especializado en VUEPACS</p>
        </div>
        <div style={{ background: '#fff', borderRadius: 12, padding: '2rem' }}>
          <p style={{ fontSize: 20, fontWeight: 700, color: '#111', marginBottom: '1.5rem', textAlign: 'center' }}>Iniciar sesion</p>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 6 }}>Usuario</label>
              <input type="text" placeholder="Tu usuario" value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' }}/>
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#333', marginBottom: 6 }}>Contrasena</label>
              <input type="password" placeholder="••••••••" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, background: '#f5f5f5', color: '#111', outline: 'none' }}/>
            </div>
            {error && <p style={{ color: '#e24b4a', fontSize: 13, marginBottom: 12 }}>{error}</p>}
            <button type="submit" disabled={cargando} style={{ width: '100%', padding: 12, background: '#1a6fbb', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
              {cargando ? 'Ingresando...' : 'Ingresar'}
            </button>
          </form>
          <p style={{ textAlign: 'center', fontSize: 13, color: '#888', marginTop: 16 }}>
            No tenes cuenta? <Link to="/registro" style={{ color: '#1a6fbb', textDecoration: 'none', fontWeight: 500 }}>Registrate</Link>
          </p>
        </div>
      </div>
    </div>
  );
}